import { routeConstants } from "constants/routeConstants";
import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAppSelector } from "slice";
import { useCheckoutMutation } from "slice/pricing";
import { useDeleteActiveSubscriptionMutation, useGetSubscriptionListQuery, useRenewSubscriptionMutation } from "slice/subscription/index";

export const useSubscription = () => {
    const [duration, setDuration] = useState("monthly");
    const { id } = useAppSelector((state) => state.user);
    const { planId } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [plans, setPlans] = useState([]);
    const [planSelected, setPlanSelected] = useState("");
    const [currentPlan, setCurrentPlan] = useState('');
    const [cancellationStatus, setCancellationStatus] = useState(null);
    const [isRenewModalOpen, setIsRenewModalOpen] = useState(false);

    const { data: subscriptionData, isLoading: subscriptionLoading } = useGetSubscriptionListQuery(
        id || "",
        { skip: !id }
    );
    const { updateSubscrptiondata: activeSubscriptionList, isLoading: subscriptionListLoading } = useDeleteActiveSubscriptionMutation(
        id || "",
        { skip: !id }
    );

    const { mutate: cancelSubscription, isLoading: isCancelling } = useDeleteActiveSubscriptionMutation();

    const [renewSubscription, { data: renewData, isLoading: isRenewing, error: renewError }] = useRenewSubscriptionMutation();

    const navigateTo = useNavigate()
    const handleRenewSubscription = async () => {
        try {
            const billingResponse = await renewSubscription(id);
            const billingUrl = billingResponse?.data?.url;

            if (billingUrl && currentPlan !== "Free") {
                window.location.href = billingUrl;
            } else {
                setIsRenewModalOpen(true)
            }
        } catch (error) {
            console.error("Failed to renew subscription:", error);
        }
    };

    const handleCancelPlan = async () => {
        if (subscriptionData?.active_subscription?.id) {
            try {
                await cancelSubscription(subscriptionData.active_subscription.id);
                setCancellationStatus('Your current plan is canceled.');
                setCurrentPlan(null);
            } catch (error) {
                console.error('Failed to cancel subscription:', error);
                setCancellationStatus('Failed to cancel the subscription.');
            }
        } else {
            setCancellationStatus('No subscription found to cancel.');
        }
    };


    const [checkout, { data: checkoutData, isLoading: isLoadingCheckout }] = useCheckoutMutation();

    const handleDurationChange = useCallback((val) => setDuration(val), []);

    const handleChoosePlan = useCallback(
        (planId) => {
            setPlanSelected(planId);
            checkout({
                price_id: planId,
                user_id: id || "",
                success_url:
                    window.location.origin + routeConstants.purchase.success,
                cancel_url:
                    window.location.origin + routeConstants.purchase.cancel,
            });
        },
        [checkout, id]
    );

    useEffect(() => {
        if (subscriptionData?.active_subscription) {

            const currentplans = subscriptionData?.active_subscription.plan?.metadata?.name || "Free";
            setCurrentPlan(currentplans);
            // Update current plan
            // if (subscriptionData && subscriptionData.active_subscription) {
            //     const currentPlanId = subscriptionData.active_subscription.plan.id;
            //     const currentPlan = currentplans.find(plan => plan.id === currentPlanId);
            //     setCurrentPlan(currentPlan || null);
            // }

            const id = setTimeout(() => setIsLoading(false), 200);

            return () => clearTimeout(id);
        }
    }, [subscriptionData]);

    useEffect(() => {
        if (planId) {
            setIsLoading(true);
            handleChoosePlan(planId);
        }
    }, [planId, handleChoosePlan]);

    useEffect(() => {
        if (checkoutData) {
            window.location.href = checkoutData.session.url;
        }
    }, [checkoutData]);

    useEffect(() => {
        if (renewError) {
            setIsRenewModalOpen(true);
        }
    }, [renewError]);

    const handleCloseRenewModal = () => {
        setIsRenewModalOpen(false);
    };

    const navigateToPlans = () => {
        navigateTo(`/${routeConstants.settings.plans}`);
        setIsRenewModalOpen(false);
    };


    return {
        duration,
        plans,
        planId,
        handleDurationChange,
        handleCancelPlan,
        planSelected,
        currentPlan,
        isFetchingPlans: isLoading || subscriptionLoading,
        handleChoosePlan,
        isLoadingCheckout,
        handleRenewSubscription,
        isRenewing,
        isRenewModalOpen,
        handleCloseRenewModal,
        navigateToPlans
    };
};
